import { FabricGrade } from '../../interfaces/stock.interface';

export type StockInSource = 'RETURN_FROM_CONSUMPTION' | 'OPENING_STOCK' | 'OTHER_ADJUSTMENT';

export const STOCK_IN_SOURCE_OPTIONS: { value: StockInSource; label: string }[] = [
    { value: 'RETURN_FROM_CONSUMPTION', label: 'Return from consumption' },
    { value: 'OPENING_STOCK', label: 'Opening stock' },
    { value: 'OTHER_ADJUSTMENT', label: 'Other adjustment' },
];

export interface StockInOut {
    /** W3-I: tag the consumption with a buyer order (cost goes to that order\'s WIP). */
    buyerOrderId?: string;
    /** Required on stock-in: decides the ledger entry's credit account. */
    source?: StockInSource;
    storeId: string;
    itemId: string;
    amount: number;
    unitCost?: number;
    remarks?: string;
    stockLotId?: string;
    dyeLot?: string;
    shade?: string;
    widthCm?: number;
    gsm?: number;
    rollCount?: number;
    supplierBatchRef?: string;
    grade?: FabricGrade;
    notes?: string;
    // ---- F6a: lot dates (stock-in only; required expiry for an expiry-tracked item) ----
    expiryDate?: string;
    manufactureDate?: string;
    // ---- F6b: one serial per unit for a serial-tracked item (captured on stock-in, picked on stock-out) ----
    serials?: string[];
    /** Stock-out of a returnable item: who holds it (an employee, a department, or both). */
    holderUserId?: string;
    holderDepartmentId?: string;
}